dmx.config.mapping['a'] = 'link';
